import type { ProTableProps } from '@ant-design/pro-components'

import { TABLE_COLUMNS_COUNT } from 'src/constants'

export type TablePersistenceScope = {
  organizationId?: number | string | null
  userId?: number | string | null
}

export const generateTablePersistenceKey = (
  tableIdentifier: string,
  scope?: TablePersistenceScope | null
): string => {
  const orgPart = scope?.organizationId
    ? `org-${scope.organizationId}`
    : 'org-unknown'
  const userPart = scope?.userId ? `user-${scope.userId}` : 'user-unknown'

  return `${orgPart}:${userPart}:${tableIdentifier}`
}

export const generateAutoColumnsState = <T extends Record<string, unknown>>(
  tableIdentifier: string | undefined,
  columnCount: number,
  scope?: TablePersistenceScope | null,
  existingColumnsState?: ProTableProps<
    T,
    Record<string, unknown>
  >['columnsState']
): ProTableProps<T, Record<string, unknown>>['columnsState'] | undefined => {
  if (
    existingColumnsState !== undefined ||
    !tableIdentifier ||
    columnCount < TABLE_COLUMNS_COUNT
  ) {
    return undefined
  }

  const persistenceKey = generateTablePersistenceKey(tableIdentifier, scope)

  return {
    persistenceKey,
    persistenceType: 'localStorage' as const
  }
}
